<template>
  <m-box title="Demography">
    <div class="m-block" style="margin-bottom: 0; ">
      <div class="m-slide-height">
        <p v-show="demos.length === 0">Use the tabs below to define your target audience using demographic or interest and purchasing attributes</p>
        <m-slide-item :items="demos" :deleteFun="deleteDemo"/>
      </div>
      <b-btn class="m-btn-pup" @click="$router.push({name:'demo'})" :disabled="isAllHoseholds"> Edit</b-btn>
      <m-demo-all-check/>
    </div>

    <div class="m-block" style="margin-bottom: 0; ">
      <div class="m-link-go"
            @click = "saveQuickPick">Save As a QuickPick </div>

      <div class="m-link-go" v-if = "datasource.hasRecordsWithPhone" style="margin-top: 8px">
          <span @click = "showTotalRecords">Total Records vs Total with Phone</span>
        </div>
    </div>

  </m-box>
</template>

<script>
  import MBox from '@/components/common/MBox'
  import MSlideItem from '@/components/slide/MSlideItem.vue'
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'

  export default {
    components: {
      MBox,
      MSlideItem,
      MDemoAllCheck
    },
    data () {
      return {}
    },
    computed: {
      demos () {
        return this.$store.getters['order/demos']
      },
      datasource () {
        return this.$store.getters['config/datasource']
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      }
    },
    methods: {
      deleteDemo (item) {
        if (item.hasOwnProperty('is50')) {
          if (item.key === 'target') {
            let targetoption = this.$store.getters['order/targetOption']
            this.$store.commit('order/saveKey', ['TargetOption', targetoption - item.value])
            this.$store.commit('demo/removeoption', {key: 'target', val: item.value})
          } else {
            let targetoption = this.$store.getters['order/routeOption']
            this.$store.commit('order/saveKey', ['RouteOption', targetoption - item.value])
            this.$store.commit('demo/removeoption', {key: 'route', val: item.value})
          }
        } else {
          this.$store.dispatch('order/deleteDemo', {
            type: 'value',
            attributeValue: item.AttributeValue,
            columnName: item.ColumnName,
            name: item.AttributeValueName,
            demoCategoryType: item.DemoCategoryType
          })
        }
      },
      saveQuickPick () {
        this.$root.$emit('bv::show::modal', 'saveQuickPick')
      },
      showTotalRecords () {
        this.$root.$emit('bv::show::modal', 'totalRecords')
      }
    }
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/order2/MOrder2Demo.vue